"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProxyFromDataset = void 0;
var data_model_1 = require("@rdfjs/data-model");
var objectToJsonRepresentation_1 = require("./objectToJsonRepresentation");
function getProxyFromDataset(target, key, dataset, contextUtil, proxyCreator) {
    if (key === "@id") {
        if (target["@id"].termType === "BlankNode") {
            return undefined;
        }
        return contextUtil.iriToKey(target["@id"].value);
    }
    if (key === "@context") {
        return contextUtil.context;
    }
    if (key === "toString" || key === Symbol.toStringTag) {
        // TODO: this toString method right now returns [object Object],
        // which is correct, but it could be more descriptive, especially
        // because console.log doesn't return anyting helpful due to the proxy.
        return Reflect.get(target, "toString");
    }
    if (typeof key === "symbol") {
        return;
    }
    var subject = target["@id"];
    var predicate = (0, data_model_1.namedNode)(contextUtil.keyToIri(key));
    if (contextUtil.isArray(key)) {
        var arrayProxy = proxyCreator.createArrayProxy([subject, predicate], dataset, contextUtil);
        return arrayProxy;
    }
    var objectDataset = dataset.match(subject, predicate);
    if (objectDataset.size === 0) {
        return undefined;
    }
    else if (objectDataset.size === 1) {
        return (0, objectToJsonRepresentation_1.objectToJsonldRepresentation)(objectDataset.toArray()[0], dataset, contextUtil, proxyCreator);
    }
    else {
        return proxyCreator.createArrayProxy([subject, predicate], dataset, contextUtil);
    }
}
exports.getProxyFromDataset = getProxyFromDataset;
